import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";

import { zinc } from "./colors";

type Option<T extends string> = { label: string; value: T };

export default function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    <Box
      component="ul"
      sx={{
        display: "flex",
        alignItems: "center",
        border: `1px solid ${zinc[500]}`,
        borderRadius: 1,
        mb: 1,
        listStyle: "none",
        p: 0,
      }}
    >
      {options.map((option, i) => {
        const isFirst = i === 0;
        const isLast = i === options.length - 1;
        return (
          <Box component="li" key={option.value} sx={{ flex: 1 }}>
            <ButtonBase
              onClick={() => onChange(option.value)}
              sx={{
                width: "100%",
                display: "block",
                py: 0.5,
                px: 1,
                textAlign: "center",
                borderRadius: 1,
                ...(!isFirst && { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                ...(!isLast && {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderRight: `1px solid ${zinc[500]}`,
                }),
                ...(option.value === value
                  ? { bgcolor: (theme) => theme.palette.brandPrimary[500], color: "white" }
                  : { bgcolor: "transparent", color: "white" }),
              }}
            >
              {option.label}
            </ButtonBase>
          </Box>
        );
      })}
    </Box>
  );
}
